import axios from 'axios'

import {
  AuthBackendApi,
  AuthBackendApiImpl,
  FetchClient,
  IoCContainer,
  MetricsBackendApi,
  MetricsBackendApiImpl,
} from '@writefull/core'

import { MetricType, MetricsFrontend } from '@domain/metrics'

import { SessionStore, SessionStoreState } from '@infrastructure/stores/session/session-store'

import NLPBackendApi from './nlp/nlp-backend-api'

export const registerBackendApis = (container: IoCContainer, env: ImportMetaEnv) => {
  const http = axios.create({
    timeout: 60000,
  })

  container.bind(FetchClient).toConstantValue(new FetchClient(http))

  container.bind(NLPBackendApi).toSelf()
  container
    .bind<AuthBackendApi>(AuthBackendApiImpl)
    .toDynamicValue(
      (c) =>
        new AuthBackendApiImpl(
          c.container.get(FetchClient),
          env.VITE_WF_AUTH_URL,
          env.VITE_WF_NLP_URL,
        ),
    )

  container
    .bind<MetricsBackendApi<MetricsFrontend, MetricType>>(MetricsBackendApiImpl)
    .toDynamicValue(
      (c) =>
        new MetricsBackendApiImpl<MetricsFrontend, MetricType, SessionStoreState>(
          c.container.get(FetchClient),
          env.VITE_WF_METRICS_URL,
          c.container.get(SessionStore),
        ),
    )
}
